/*
 * Jira Ticket:
 * Created Date: Fri, 21st Feb 2020, 10:02:24 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import Card from '@material-ui/core/Card';
import { dashboardStyles } from 'styles';

const CardIcon = ({ Icon, bgColour }) => {
  const classes = dashboardStyles(bgColour);
  return (
    <Card className={classes.card}>
      <Icon className={classes.icon} />
    </Card>
  );
};

export default CardIcon;
